import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { AuthService } from './auth.service';
import { environment as env } from '../../environments/environment';
import { User, UserGroup, Application, Menu, AuthorizationObject, UserObject } from '../models/Datatype';

@Injectable()
export class GlobalService {
  blockUI: boolean = false;
  localeId: any;
  device = 'desktop';
  version = "";
  message = "";

  constructor(public http: HttpClient, public router: Router,private auth:AuthService) {
    if (window.innerWidth < 700) {
      this.device = 'mobile';
    }

    this.localeId = {
      firstDayOfWeek: 0,
      dayNames: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'],
      dayNamesShort: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
      dayNamesMin: ['M', 'S', 'S', 'R', 'K', 'J', 'S'],
      monthNames: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
        'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
      today: 'Hari Ini',
      clear: 'Hapus'
    };

    this.errorHandler = this.errorHandler.bind(this);
  }

  onBlockDispose(){
    this.message = "";
  }

  reloadSession(){
    return new Promise((resolve,reject)=>{
      localStorage.clear();
      if (env["currentAppUrl"] == "orchestra-login") {
        this.loadAppAuth().then(()=>{
          resolve(true);
        });
      } else {
        this.loadMenuAuth().then(()=>{
          resolve(true);
        });
      }
    });
  }

  loadAppAuth(){
    return new Promise((resolve,reject)=>{
      this.get("msuser/getusername")
      .then(rows => {
        let userName = rows[0];
        return this.get(`msuser/detail/${userName}`);
      }).then(rows => {
        this.auth.user = <User>rows[0];
        this.auth.isLoggedIn = true;
        return this.get(`msuser/${this.auth.user.userName}/group-list`);
      })
      .then(rows => {
        this.auth.user.groups = <UserGroup[]>rows;

        return this.get(`msuser/${this.auth.user.userName}/app-list`);
      })
      .then(rows => {
        this.auth.user.apps = <Application[]>rows;
        this.auth.user.apps.forEach(app => {
          app.appUrl = app.appUrl;
        });
        return this.auth.saveSession();
      })
      .then(()=>{
        resolve(true);
      }).catch(err => {
        reject();
      });
    });
  }

  loadMenuAuth(){
    return new Promise((resolve,reject)=>{
      this.getLoginApi("msuser/getusername")
      .then(rows => {
        let userName = rows[0];
        return this.getLoginApi(`msuser/detail/${userName}`);
      }).then(rows => {
        this.auth.user = <User>rows[0];
        this.auth.isLoggedIn = true;

        return this.getLoginApi(`msuser/${this.auth.user.userName}/group-list`);
      })
      .then(rows => {
        this.auth.user.groups = <UserGroup[]>rows;

        return this.getLoginApi(`msuser/${this.auth.user.userName}/app-list`);
      })
      .then((rows: any) => {
        this.auth.user.apps = <Application[]>rows;
        this.auth.currentApp = rows.find(x => x.appUrl == env["currentAppUrl"]);
        if (this.auth.currentApp != undefined) {
          sessionStorage.setItem("appServer", this.auth.currentApp.appServer);
        } else {
          sessionStorage.setItem("appServer", "");
        }
        return this.getLoginApi(`msuser/${this.auth.user.userName}/${env["currentAppUrl"]}/menu-list`);
      })
      .then((rows: any[]) => {
        let arrAction: string[];
        let arrAction2: string[];

        this.auth.user.menus = [];
        rows.forEach(row => {
          let menu: Menu = <Menu>row;

          arrAction2 = [];
          arrAction = menu.action.split(',');
          arrAction.forEach(action => {
            if (arrAction2.indexOf(action) == -1) arrAction2.push(action);
          })
          menu.action = arrAction2.join(',');

          this.auth.user.menus.push(menu);
        });
        this.auth.menus = this.generateSubMenuItem(this.auth.user.menus, '');

        return this.getLoginApi(`msuser/${this.auth.user.userName}/${env["currentAppUrl"]}/auth-obj-list`);
      })
      .then((rows: any[]) => {
        this.auth.user.authObjects = {};
        rows.forEach(row => {
          let authObj: AuthorizationObject = <AuthorizationObject>row;

          if (this.auth.user.authObjects[authObj.appUrl] == undefined) {
            this.auth.user.authObjects[authObj.appUrl] = {};
          }
          if (this.auth.user.authObjects[authObj.appUrl][authObj.objCode] == undefined) {
            this.auth.user.authObjects[authObj.appUrl][authObj.objCode] = [];
          }
          this.auth.user.authObjects[authObj.appUrl][authObj.objCode].push(authObj);
        });
        return this.getLoginApi(`msuser/${this.auth.user.userName}/${env["currentAppUrl"]}/user-obj-list`);
      })
      .then((rows: any[]) => {
        this.auth.user.userObjects = {};
        rows.forEach(row => {
          let userObj: UserObject = <UserObject>row;

          if (this.auth.user.userObjects[userObj.appUrl] == undefined) {
            this.auth.user.userObjects[userObj.appUrl] = {};
          }
          if (this.auth.user.userObjects[userObj.appUrl][userObj.objCode] == undefined) {
            this.auth.user.userObjects[userObj.appUrl][userObj.objCode] = [];
          }
          this.auth.user.userObjects[userObj.appUrl][userObj.objCode].push(userObj);
        });
        return this.auth.saveSession();
      }).then(()=>{
        this.auth.loadPlant();
        resolve(true);
      }).catch(error=>{
        reject();
      });
    });
  }

  generateSubMenuItem(dictMenu: Menu[], parentUrl: string): any[] {
    let result: any[] = [];
    let item: any;

    dictMenu.forEach(menu => {
      if (menu.parentUrl == parentUrl) {
        item = {
          id: menu.menuUrl,
          text: menu.menuDesc,
          icon: menu.menuIcon,
          items: this.generateSubMenuItem(dictMenu, menu.menuUrl)
        };

        if (item.items.length == 0) {
          item.url = '/' + menu.menuUrl;
          delete item.items;
        }

        result.push(item);
      }
    })

    return result;
  }


  isAuthenticated() {
    return new Promise((resolve) => {
      if (this.auth.getCookie('token') != undefined) {
        this.reloadSession().then(()=>{
          if (this.auth.user == null && this.router.url.indexOf('public') < 0) {
            this.auth.setRedirectUrl();
            if (this.router.url != '/login') {
              this.router.navigate(['/login']);
            }
            resolve(false);
          } else {
            resolve(true);
          }
        }).catch((error) => {
          console.log(error);
          resolve(false);
        });
      } else {
        this.auth.setRedirectUrl();
        this.router.navigate(['/login']);
        resolve(false);
      }
    });
  }

  get(url: string,showError:boolean=true) {
    return new Promise((resolve,reject)=>{
      var headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.auth.getCookie('token')}`
      });
      // return this.http.get(this.config["api" + sessionStorage.getItem("appServer") + "Url"] + url, { headers: headers, withCredentials: true }).toPromise();
      this.http.get(env["apiUrl"] + url, { headers: headers, withCredentials: true }).toPromise().then(result=>{
        if (result["result"]) {
            resolve(result["rows"]);
          } else {
            this.errorHandler(result,showError);
            reject(result);
          }
        })
        .catch(result => {
          this.errorHandler(result,showError);
          reject(result);
        });
    });
  }

  getLoginApi(url: string,showError:boolean=true) {
    return new Promise((resolve, reject) => {
      var headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.auth.getCookie('token')}`
        });
      this.http.get(env["apiUrl"] + url, { headers: headers, withCredentials: true }).toPromise()
      .then(result => {
        if (result["result"]) {
            resolve(result["rows"]);
          } else {
            this.errorHandler(result,showError);
            reject(result);
          }
        })
        .catch(result => {
          this.errorHandler(result,showError);
          reject(result);
        });
    });
  }

  errorHandler(result:any,showError:boolean=true) {
    let errMsg = "";
    console.log(result.status);
    if (result.status == 401) {
      this.goToLoginPage();
    }else if (result.message != undefined) {
      errMsg = result.message;
    } else if (result.error instanceof ErrorEvent) {
      errMsg = 'An error occurred:', result.error.message;
    } else {
      errMsg = `Backend returned code ${result.status}, ` + `body was: ${result.error}`;
    }

    if(showError){
      this.showErrorDialog(errMsg);
    }
  }

  goToLoginPage() {
    localStorage.clear();
    sessionStorage.clear();
    this.auth.clearCookies();
    this.router.navigate(['/login']);
  }

  post(url: string, body: any,showError:boolean=true) {
    return new Promise((resolve, reject) => {
        var headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.auth.getCookie('token')}`
        });
        // return this.http.post(this.config["api" + sessionStorage.getItem("appServer") + "Url"] + url, body, { headers: headers, withCredentials: true }).toPromise();
        this.http.post(env["apiUrl"] + url, body, { headers: headers, withCredentials: true }).toPromise()
        .then(result => {
          if (result["result"]) {
            resolve(result["rows"]);
          } else {
            this.errorHandler(result,showError);
            reject(result);
          }
        })
        .catch(result => {
          this.errorHandler(result,showError);
          reject(result);
        });
    });
  }

  postLoginApi(url: string, body: any,showError:boolean=true) {
    return new Promise((resolve, reject) => {
        var headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.auth.getCookie('token')}`
        });
        this.http.post(env["apiUrl"] + url, body, { headers: headers, withCredentials: true }).toPromise()
        .then(result => {
          if (result["result"]) {
            resolve(result["rows"]);
          } else {
            this.errorHandler(result,showError);
            reject(result);
          }
        })
        .catch(result => {
          this.errorHandler(result,showError);
          reject(result);
        });
    });
  }

  showErrorDialog(message: string) {
    let option = {
      closeOnClick: true,
      message: message
    };

    notify(option, 'error', 10000);
    /*this.confirmClass = 'orchestra-error';
    this.confirmation.confirm({
        header: 'Error',
        message: message,
        icon: 'fa fa-warning',
        accept: () => {}
    });*/
  }

  showMessageDialog(message: string) {
    let option = {
      closeOnClick: true,
      message: message
    };

    notify(option, 'info', 10000);

    /*this.confirmClass = '';
    this.confirmation.confirm({
        header: 'Message',
        message: message,
        icon: 'fa fa-info',
        accept: () => {}
    });*/
  }

  showSuccessDialog(message: string) {
    let option = {
      closeOnClick: true,
      message: message
    };

    notify(option, 'success', 10000);

    /*this.confirmClass = 'orchestra-success';
    this.confirmation.confirm({
        header: 'Message',
        message: message,
        icon: 'fa fa-check-circle',
        accept: () => {}
    });*/
  }

  toggleBlockUI() {
    this.blockUI = !this.blockUI;
  }
  
  RemoveZero(param: string) {
    let start = 0;
    for (let i = 0; i < param.length; i++) {
      if (param[i] == '0') {
        start++;
      } else {
        break;
      }
    }

    let returnValue = param.substring(start, param.length);
    return returnValue;
  }

  AddZero(param: string, length: number) {
    let add = '';
    for (let i = 0; i < (length - param.length); i++) {
      add += '0';
    }

    let returnValue = add + param;
    return returnValue;
  }

  formatSAPDate(date: Date, separate: boolean) {
    if (separate)
      return ("0" + date.getDate()).slice(-2) + '.' + ("0" + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear();
    else
      return date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + date.getDate()).slice(-2);
  }

  formatSAPTime(time: Date, separate: boolean) {
    if (separate)
      return ("0" + time.getHours()).slice(-2) + ':' + ("0" + time.getMinutes()).slice(-2) + ":" + ("0" + time.getSeconds()).slice(-2);
    else
      return ("0" + time.getHours()).slice(-2) + ("0" + time.getMinutes()).slice(-2) + ("0" + time.getSeconds()).slice(-2);
  }

  sortArrayOfObjectAsc(array: any[], property: string) {
    for (let i = 0; i < array.length - 1; i++) {
      for (let j = 0; j < array.length - i - 1; j++) {
        if (array[j][property].localeCompare(array[j + 1][property]) > 0) {
          let x = array[j];
          array[j] = array[j + 1];
          array[j + 1] = x;
        }
      }
    }

    return array;
  }

  replaceAll(fullString: string, find: string, replace: string) {
    for (var i = 0; i < 10; i++) {
      fullString = fullString.replace(find, replace);
    }
    return fullString;
  }

  getConfigSession(value) {
    let data = JSON.parse(sessionStorage.getItem('config'));
    return data[value];
  }

  getLocalStorage(value) {
    let data = localStorage.getItem(value);
    return data;
  }

  formatDate(date: Date, format: string) {
    var formatted = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);

    if (format == 'dd.mm.yyyy') {
      formatted = ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear();
    } else if (format == 'dd-mm-yyyy') {
      formatted = ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
    } else if (format == 'dd/mm/yyyy') {
      formatted = ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + date.getFullYear();
    } else if (format == 'ddmmyyyy') {
      formatted = ('0' + date.getDate()).slice(-2) + ('0' + (date.getMonth() + 1)).slice(-2) + date.getFullYear();
    } else if (format == 'yyyy.mm.dd') {
      formatted = date.getFullYear() + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + ('0' + date.getDate()).slice(-2);
    } else if (format == 'yyyy-mm-dd') {
      formatted = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
    } else if (format == 'yyyy/mm/dd') {
      formatted = date.getFullYear() + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2);
    } else if (format == 'yyyymmdd') {
      formatted = date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2);
    } else if (format == 'HHmmss') {
      formatted = ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2);
    }
    return formatted;
  }

  getCross(bukrs: string, url: string,showError:boolean=true) {
    let srv = this.getServer(bukrs);

    return new Promise((resolve, reject) => {
          // this.http.get(this.config["api" + srv + "Url"] + url, { withCredentials: true }).toPromise();
        this.http.get(env["apiUrl"] + url, { withCredentials: true }).toPromise()
        .then(result => {
          if (result["result"]) {
            resolve(result["rows"]);
          } else {
            this.errorHandler(result,showError);
            reject(result);
          }
        })
        .catch(result => {
          this.errorHandler(result,showError);
          reject(result);
        });
    });
  }

  postCross(bukrs: string, url: string, body: any,showError:boolean=true) {
    let srv = this.getServer(bukrs);

    return new Promise((resolve, reject) => {
          // return this.http.post(this.config["api" + srv + "Url"] + url, body, { withCredentials: true }).toPromise();
        this.http.post(env["apiUrl"] + url, body, { withCredentials: true }).toPromise()
        .then(result => {
          if (result["result"]) {
            resolve(result["rows"]);
          } else {
            this.errorHandler(result,showError);
            reject(result);
          }
        })
        .catch(result => {
          this.errorHandler(result,showError);
          reject(result);
        });
    });
  }

  getServer(bukrs) {
    if (bukrs == "A002")
      return "Wings";
    else if (bukrs == "A004")
      return "KAS";
    else if (bukrs == "A009")
      return "MAS";                   
    else if (bukrs == "A010")
      return "MAS";
    else if (bukrs == "A023")
      return "KIA";
    else if (bukrs == "A024")
      return "KIA";
    else
      return "";
  }

  getIsMAS(bukrs) {
    let srv = this.getServer(bukrs);
    if (srv == "MAS")
      return true;
    else return false;
  }

  getIsKAS(bukrs) {
    let srv = this.getServer(bukrs);
    if (srv == "KAS")
      return true;
    else return false;
  }

  getIsWings(bukrs) {
    let srv = this.getServer(bukrs);
    if (srv == "Wings")
      return true;
    else return false;
  }

  getIsKIA(bukrs) {
    let srv = this.getServer(bukrs);
    if (srv == "KIA")
      return true;
    else return false;
  }

  getIsABP(bukrs) {
    let srv = this.getServer(bukrs);
    if (srv == "ABP")
      return true;
    else return false;
  }

  CountDayDiff(firstDate: Date, secondDate: Date) {
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

    const diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay));
    return diffDays;
  }

}
